import { Injectable, Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { MenuItem } from '@awp/models';
import { MENU_TOKEN, MenuService } from '@awp/app-common';

@Injectable({
  providedIn: 'root'
})
export class MenuResolver implements Resolve<any> {

  constructor(@Inject(MENU_TOKEN) private menuService: MenuService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MenuItem> {
    const menuId = route.paramMap.get('menuId');
    return this.menuService.values.pipe(
      map(items => {
        const page = items.find(i => i.url === menuId);
        if (page == null) {
          console.warn(`Page '${menuId}' not found`);
        }
        return page;
      }),
      take(1)
    );
  }
}
